import { Component, Input } from '@angular/core';
import { Patient } from '../../../models/patient';
import { TraitementDataDebitMinMaxComponent } from "../../traitement-data/traitement-data-debit-min-max/traitement-data-debit-min-max.component";
import { TraitementDataDureeMinMaxComponent } from "../../traitement-data/traitement-data-duree-min-max/traitement-data-duree-min-max.component";
import { TraitementDataComponent } from "../../traitement-data/traitement-data/traitement-data.component";

@Component({
  selector: 'app-traitement-avf-card',
  standalone: true,
  imports: [TraitementDataDebitMinMaxComponent, TraitementDataDureeMinMaxComponent, TraitementDataComponent],
  templateUrl: './traitement-avf-card.component.html',
  styleUrl: './traitement-avf-card.component.scss'
})
export class TraitementAvfCardComponent {
  @Input() patient: Patient | undefined;
}
